import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { expenseEntryInitialsForAdd, expenseEntryInitialsForUpdate } from '../interfaces/expenseClass';
import {
    getExpenseSheetByAccountEmployeeIdAsync, resetSelectedRecordObjectInState, getCalculationsFieldsByAccountExpenseIdAsync,
    addAccountEmployeeExpenseSheetAsync, addAccountExpenseEntryAsync, getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync, updateAccountExpenseEntryAsync,
    SetDefaultExpenseRateAsync, GetExpenseCalculateAmountAsync, updateIsCanvasLoading, setPreferenceOptions, updateAccountEmployeeId,
    updateMasterExpenseSheetId
} from '../expenseSlice';
import * as yup from 'yup';
import { Formik } from 'formik';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import Select, { StylesConfig } from 'react-select';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import clsx from 'clsx';
import { useFormik } from 'formik';
import { AttachmentUpload } from '../../attachment/AttachmentUpload'
import { addAttachment } from '../../attachment/AttachmentSlice';
import GetAttachments from '../../attachment/AttachmentItem';
import { useTranslation } from "react-i18next";
import { validateCultureNumber, determineCommaSeprater, parseLocalizedNumber, formatNumberCustomoriginalapiv2, formatNumberCustomoriginal, dropDownSelectionStyles, dateFormatByAccountCulture, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import CanvasLoader from '../../../common/CanvasLoader';


const objDropdown = {
    clients: [],
    projects: [],
    projectTask: [],
    expenses: [],
    paymentMethod: [],
    currency: [],
    taxZone: [],
    isLoading: true,
}


const objExpenseValues = {
    AccountExpenseEntryDate: new Date(),
    AccountId: 0,
    AccountEmployeeId: 0,
    AccountProjectId: 0,
    AccountExpenseId: 0,
    Description: "",
    Amount: 0,
    TeamLeadApproved: false,
    ProjectManagerApproved: false,
    AdministratorApproved: false,
    Approved: false,
    TimeSheetApprovalPathId: 0,
    CreatedOn: new Date(),
    CreatedByEmployeeId: 0,
    ModifiedOn: new Date(),
    ModifiedByEmployeeId: 0,
    IsBillable: false,
    Rejected: false,
    Quantity: 0,
    Rate: 0,
    AmountBeforeTax: 0,
    TaxAmount: 0,
    Reimburse: false,
    AccountCurrencyId: 0,
    AccountPaymentMethodId: 0,
    AccountBaseCurrencyId: 0,
    ExchangeRate: 0,
    Submitted: false,
    AccountTaxZoneId: 0,
    AccountTimeExpenseBillingExpenseId: '',
    AccountEmployeeExpenseSheetId: '',
    OldAccountExpenseEntryId: 0,
    AccountProjectTaskId: 0,
    IsEmailSend: 0,
    AccountClientId: 0,
    AccountExpenseEntryGuidId: "",
    AccountExpensePolicyPerDiemTypeId: 0,
    AccountExpensePolicyPerDiemLocationId: 0,
    isCanvasLoader: true,
    CustomField1: "",
    CustomField2: "",
    CustomField3: "",
    CustomField4: "",
    CustomField5: "",
    CustomField6: "",
    CustomField7: "",
    CustomField8: "",
    CustomField9: "",
    CustomField10: "",
    CustomField11: "",
    CustomField12: "",
    CustomField13: "",
    CustomField14: "",
    CustomField15: ""
}

const ExpenseEntryForm = () => {
    const dispatch = useAppDispatch();
    // const attachmentUploadClearRef = useRef<any>(null);
    // const [tempAttachmentId, setTempAttachmentId] = useState(null);

    const [tempAttachmentId, setTempAttachmentId] = useState(null);
    const attachmentUploadClearRef = useRef<any>(null);
    const location = useLocation();
    // const params = new URLSearchParams(location.search);
    const { t } = useTranslation();
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(expenseEntryInitialsForAdd);
    const { obj } = location.state || {};
    const navigate = useNavigate();

    const { decimalPlaces, pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, sessionAccountEmployeeId, accountBaseCurrencyId, maxMenuHeight, CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, customFieldInsertionFormat, calendarStartDay, enableUploadFeature } = useAppSelector((state) => state.globalState);

    const { expenseSheetList, isReload, selectedRecord, expensesheetDate, expenseSheetDescription, reimburseCurrencyId, isLoading,
        MasterEmployeeExpenseSheetId, AccountEmployeeId, AccountExpenseEntryId, DecimalPlaces, LockButton } = useAppSelector((state) => state.expense);
    const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
    const [messages, setMessages] = useState<any>([]);
    const [isValid, setIsValid] = useState(false);
    const typingTimeoutRef = useRef<any>(null);




    let AccountEmployeeExpenseSheetId = '';
    // dispatch(updateAccountEmployeeId(sessionAccountEmployeeId));

    if (MasterEmployeeExpenseSheetId && MasterEmployeeExpenseSheetId !== '') {
        AccountEmployeeExpenseSheetId = MasterEmployeeExpenseSheetId;
    } else if (obj && obj.AccountEmployeeExpenseSheetId) {
        AccountEmployeeExpenseSheetId = obj.AccountEmployeeExpenseSheetId;
    }
    const updateMasterIdInState = (newMasterId: any) => {
        navigate(location.pathname, {
            state: {
                ...location.state,
                obj: {
                    ...obj,
                    AccountEmployeeExpenseSheetId: newMasterId,
                },
            },
            replace: true,
        });
    };


    const [tab, setTab] = useState('Basic');
    const [isCheckedBillable, setIsCheckedBillable] = useState(false);
    const [isCheckedReimburse, setIsCheckedReimburse] = useState(false);
    const [selectedClient, setSelectedClient] = useState<{ [object: string]: any }>();
    const [clientArray, setClientArray] = useState([]);
    const [selectedProject, setSelectedProject] = useState<{ [object: string]: any }>();
    const [projectArray, setProjectArray] = useState([]);
    const [selectedTask, setSelectedTask] = useState<{ [object: string]: any }>();
    const [taskArray, setTaskArray] = useState([]);
    const [selectedExpense, setSelectedExpense] = useState<{ [object: string]: any }>();
    const [expenseArray, setExpenseArray] = useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<{ [object: string]: any }>();
    const [paymentMethodArray, setPaymentMethodArray] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState<{ [object: string]: any }>();
    const [currencyArray, setCurrencyArray] = useState([]);
    const [selectedTaxZone, setSelectedTaxZone] = useState<{ [object: string]: any }>();
    const [taxZoneArray, setTaxZoneArray] = useState([]);
    const [ShowQuantity, setShowQuantity] = useState(false);
    const [ShowNetAmount, setShowNetAmount] = useState(false);
    const [ShowRate, setShowRate] = useState(false);
    const [ShowTax, setShowTax] = useState(false);
    const [ShowTaxZone, setShowTaxZone] = useState(false);
    const [expenseResponse, setExpenseResponse] = useState<any | ''>(objDropdown);
    const [expenseValues, setExpenseValues] = useState<any | ''>(objExpenseValues);
    const [projectValues, setProjectValues] = useState<any | ''>([]);
    const currentDate = new Date();
    const [SelectedExpenseEntryDate, setSelectedExpenseEntryDate] = useState(currentDate);
    const [SelectedEntryDate, setSelectedEntryDate] = useState(currentDate);
    const [expenseId, setExpenseId] = useState(0);
    const [id, setId] = useState('');
    const [value, setvalue] = useState('');
    const [finalAmount, setFinalAmount] = useState(0);
    const [taxAmount, setTaxAmount] = useState('');
    const [showClientInExpenseSheet, SetShowClientInExpenseSheet] = useState(false);
    const [showTaskInExpenseSheet, SetShowTaskInExpenseSheet] = useState(false);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const closeButtonRef1 = useRef<HTMLButtonElement | null>(null);
    const [apiErrors, setApiErrors] = useState<string[]>([]);
    const [istaxzone, setistaxzoneid] = useState(0);


    const objDefaultValues = {
        AccountClientId: 0,
        AccountProjectId: 0,
        AccountExpenseId: 0,
        AccountPaymentMethodId: 0,
        AccountCurrencyId: 0,
        AccountTaxZoneId: 0
    }
    const validationSchema = yup.object().shape(
        ShowQuantity || ShowRate ? {
            AccountProjectId: yup
                .number()
                .moreThan(0,
                    getValueFromResource('Project name is required', dispatch, t))
                .required(getValueFromResource('Project name is required', dispatch, t)),
            Quantity: yup.string()
                .test(
                    'culture-format-check',
                    () => {
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        return isComma
                            ? "Only numbers and comma (,) are allowed."
                            : "Only numbers and dot (.) allowed";
                    },

                    (value) => {
                        if (!value) return true;
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        if (isComma) {
                            return /^\d+(,\d+)?$/.test(value);
                        } else {
                            return /^\d+(\.\d+)?$/.test(value);
                        }
                    }
                )
                .test(
                    'greater-than-zero',
                    getValueFromResource('Quantity must be greater than or equal to 0', dispatch, t),
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        let normalizedValue = value;
                        if (isComma) {
                            normalizedValue = value.replace(',', '.');
                        }

                        const numberValue = parseFloat(normalizedValue);
                        return !isNaN(numberValue) && numberValue >= 0;
                    }
                ),
            Rate: yup.string()
                .test(
                    'culture-format-check',
                    () => {
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        return isComma
                            ? "Only numbers and comma (,) allowed"
                            : "Only numbers and dot (.) allowed";
                    },

                    (value) => {
                        if (!value) return true;
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        if (isComma) {
                            return /^\d+(,\d+)?$/.test(value);
                        } else {
                            return /^\d+(\.\d+)?$/.test(value);
                        }
                    }
                )
                .test(
                    'greater-than-zero',
                    getValueFromResource('Rate must be greater than or equal to 0', dispatch, t),
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        let normalizedValue = value;
                        if (isComma) {
                            normalizedValue = value.replace(',', '.');
                        }

                        const numberValue = parseFloat(normalizedValue);
                        return !isNaN(numberValue) && numberValue >= 0;
                    }
                ),
            Amount: yup.string()
                .test(
                    'culture-format-check',
                    () => {
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        return isComma
                            ? "Only numbers and comma (,) allowed"
                            : "Only numbers and dot (.) allowed";
                    },

                    (value) => {
                        if (!value) return true;
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        if (isComma) {
                            return /^\d+(,\d+)?$/.test(value);
                        } else {
                            return /^\d+(\.\d+)?$/.test(value);
                        }
                    }
                )
                .test(
                    'greater-than-zero',
                    getValueFromResource('Amount must be greater than or equal to 0', dispatch, t),
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        let normalizedValue = value;
                        if (isComma) {
                            normalizedValue = value.replace(',', '.');
                        }

                        const numberValue = parseFloat(normalizedValue);
                        return !isNaN(numberValue) && numberValue >= 0;
                    }
                ),
            /*             Quantity: yup
                            .number()
                            .min(0, getValueFromResource('Quantity must be greater than or equal to 0', dispatch, t))
                            .max(99999999, getValueFromResource('Rate must be less than or equal to 99999999', dispatch, t)),
                        Rate: yup
                            .number()
                            .min(0, getValueFromResource('Rate must be greater than or equal to 0', dispatch, t))
                            .max(99999999, getValueFromResource('Rate must be less than or equal to 99999999', dispatch, t)),
                        Amount: yup
                            .number()
                            .min(0, getValueFromResource('Amount must be greater than or equal to 0', dispatch, t))
                            .max(99999999, getValueFromResource('Amount must be less than or equal to 99999999', dispatch, t)), */

            /*              Amount: yup
                            .number()
                            .min(0, getValueFromResource('Amount must be greater than or equal to 0', dispatch, t))
                            .max(99999999, getValueFromResource('Amount must be less than or equal to 99999999', dispatch, t)), */
            ...Object.fromEntries(
                customFieldsArray
                    .filter((x: any) => !x.IsDisabled)
                    .map((x: any) => {
                        let yupSchema;
                        if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                        }
                        else if (x.MasterCustomDataTypeName === 'Text') {
                            yupSchema = yup.string().trim();
                            if (x.MaximumLength != null) {
                                yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                            }
                        }
                        else if (x.MasterCustomDataTypeName === 'Date') {
                            yupSchema = yup.date()
                                .nullable()
                                .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                                .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                        }
                        if (x.IsRequired) {
                            yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                        }
                        return [x.DatabaseFieldName, yupSchema];
                    })
            )

        } : {
            AccountProjectId: yup
                .number()
                .moreThan(0, getValueFromResource('Project name is required', dispatch, t))
                .required(getValueFromResource('Project name is required', dispatch, t)),

            AmountBeforeTax: yup.string()
                // .required(getValueFromResource('Field is required', dispatch, t))
                .test(
                    'culture-format-check',
                    () => {
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        return isComma
                            ? "Sirf numbers aur comma (,) allowed hain"
                            : "Sirf numbers aur dot (.) allowed hain";
                    },
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());

                        if (isComma) {
                            return /^\d+(,\d+)?$/.test(value);
                        } else {
                            return /^\d+(\.\d+)?$/.test(value);
                        }
                    }
                )
                .test(
                    'greater-than-zero',
                    getValueFromResource('Net Amount must be greater than or equal to 0', dispatch, t),
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        let normalizedValue = value;
                        if (isComma) {
                            normalizedValue = value.replace(',', '.');
                        }

                        const numberValue = parseFloat(normalizedValue);
                        return !isNaN(numberValue) && numberValue >= 0;
                    }
                ),            
                Tax: yup.string()
                // .required(getValueFromResource('Field is required', dispatch, t))
                .test(
                    'culture-format-check',
                    () => {
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        return isComma
                            ? "Only numbers and comma (,) allowed"
                            : "Only numbers and dot (.) allowed";
                    },
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());

                        if (isComma) {
                            return /^\d+(,\d+)?$/.test(value);
                        } else {
                            return /^\d+(\.\d+)?$/.test(value);
                        }
                    }
                )
                .test(
                    'greater-than-zero',
                    getValueFromResource('Tax amount must be greater than or equal to 0', dispatch, t),
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        let normalizedValue = value;
                        if (isComma) {
                            normalizedValue = value.replace(',', '.');
                        }

                        const numberValue = parseFloat(normalizedValue);
                        return !isNaN(numberValue) && numberValue >= 0;
                    }
                ),            
                Amount: yup.string()
                // .required(getValueFromResource('Field is required', dispatch, t))
                .test(
                    'culture-format-check',
                    () => {
                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        return isComma
                            ? "Only numbers and comma (,) allowed"
                            : "Only numbers and dot (.) allowed";
                    },
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());

                        if (isComma) {
                            return /^\d+(,\d+)?$/.test(value);
                        } else {
                            return /^\d+(\.\d+)?$/.test(value);
                        }
                    }
                )
                .test(
                    'greater-than-zero',
                    getValueFromResource('Net Amount must be greater than or equal to 0', dispatch, t),
                    (value) => {
                        if (!value) return true;

                        const isComma = determineCommaSeprater(cultureInfoName.toString());
                        let normalizedValue = value;
                        if (isComma) {
                            normalizedValue = value.replace(',', '.');
                        }

                        const numberValue = parseFloat(normalizedValue);
                        return !isNaN(numberValue) && numberValue >= 0;
                    }
                ),
            /*             AmountBeforeTax: yup
                            .string()
                            .min(0, getValueFromResource('Net Amount must be greater than or equal to 0', dispatch, t))
                            .max(99999999, getValueFromResource('Net Amount must be less than or equal to 99999999', dispatch, t)),
                        Tax: yup
                            .string()
                            .min(0, getValueFromResource('Tax amount must be greater than or equal to 0', dispatch, t))
                            .max(99999999, getValueFromResource('Tax amount must be less than or equal to 99999999', dispatch, t)),
                        Amount: yup
                            .string()
                            .min(0, getValueFromResource('Amount must be greater than or equal to 0', dispatch, t))
                            .max(99999999, getValueFromResource('Amount must be less than or equal to 99999999', dispatch, t)), */
            ...Object.fromEntries(
                customFieldsArray
                    .filter((x: any) => !x.IsDisabled)
                    .map((x: any) => {
                        let yupSchema;
                        if (x.MasterCustomDataTypeName === 'Number') {
                                    yupSchema = yup
                                        .string()
                                        .test(
                                            'culture-format-check',
                                            () => {
                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                return isComma
                                                    ? `${x.CustomFieldCaption} allows only numbers and comma (,)`
                                                    : `${x.CustomFieldCaption} allows only numbers and dot (.)`;
                                            },
                                            (value) => {
                                                if (!value) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());

                                                return isComma
                                                    ? /^\d+(,\d+)?$/.test(value)
                                                    : /^\d+(\.\d+)?$/.test(value);
                                            }
                                        )

                                        // Minimum value check
                                        .test(
                                            'min-value',
                                            `${x.CustomFieldCaption} must be at least ${x.MinimumValue}`,
                                            (value) => {
                                                if (!value || x.MinimumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue >= x.MinimumValue;
                                            }
                                        )

                                        // Maximum value check
                                        .test(
                                            'max-value',
                                            `${x.CustomFieldCaption} must be at most ${x.MaximumValue}`,
                                            (value) => {
                                                if (!value || x.MaximumValue == null) return true;

                                                const isComma = determineCommaSeprater(cultureInfoName.toString());
                                                const normalizedValue = isComma
                                                    ? value.replace(',', '.')
                                                    : value;

                                                const numberValue = parseFloat(normalizedValue);
                                                return !isNaN(numberValue) && numberValue <= x.MaximumValue;
                                            }
                                        );
                        }
                        else if (x.MasterCustomDataTypeName === 'Text') {
                            yupSchema = yup.string().trim();
                            if (x.MaximumLength != null) {
                                yupSchema = yupSchema.max(x.MaximumLength, `${x.CustomFieldCaption} must be at most ${x.MaximumLength} characters`);
                            }
                        }
                        else if (x.MasterCustomDataTypeName === 'Date') {
                            yupSchema = yup.date()
                                .nullable()
                                .typeError(`Please enter a valid ${x.CustomFieldCaption}`)
                                .min(new Date('1900-01-01'), `${x.CustomFieldCaption} must be after 01/01/1900`)
                        }
                        if (x.IsRequired) {
                            yupSchema = yupSchema?.required(`${x.CustomFieldCaption} is required`);
                        }
                        return [x.DatabaseFieldName, yupSchema];
                    })
            )


        });


    const formik = useFormik({
        initialValues: {
            ...expenseValues,
            AccountProjectId: expenseValues.AccountProjectId || '', // Ensure this matches the validation schema
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        validateOnChange: false, // Disable validation on change
        validateOnBlur: false, // Disable validation on blur
        onSubmit: async (values, action) => {
            const validationResponse = await limitvalidations(values.Amount);
            if (validationResponse && validationResponse.Data && Array.isArray(validationResponse.Data)) {
                const newApiErrors = validationResponse.Data
                    .filter((item: any) => item.message !== 'true')
                    .map((item: any) => item.message);

                if (newApiErrors.length > 0) {
                    setApiErrors(newApiErrors);
                    return;
                }
            }

            handleSubmit(values);
        },
    });

    const limitvalidations = async (Amount: any) => {

        const IsDesc = formik.values.Description.length > 0 ? true : false

        try {

            let strForAmount
            let parsedAmount
            const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
            if (isCommaSeparator) {

                strForAmount = String(Amount).replace(',', '.');
                parsedAmount = parseFloat(strForAmount) || 0
            }
            if (isCommaSeparator === false) {
                strForAmount = String(Amount).replace(',', '.');
                parsedAmount = parseFloat(strForAmount)
            }
            const response = await fetchAPI('api/V2/ExpenseSheets/CheckAllow/' + AccountEmployeeId + '/' + expenseId + "/" + parsedAmount + "/" + IsDesc + "/" + false, "GET", "", true);

            if (!response.ok) {
                throw new Error('API call failed with status ' + response.status);
            }

            const json = await response.json();

            return json;
        } catch (error) {
            console.error('Error in limitvalidations:', error);
            return null;
        }
    };

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId: string = '756E4460-A713-4BEE-B3F0-708FC5BE21BD';
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, "");
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }

    const getDefaultValOfSpecificCustomField = (customField: string, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        if (foundItem) {
            // return foundItem.MasterCustomDataTypeName === 'Date' ? moment().format(CurrentCultureDateFormat.toUpperCase()) : (foundItem.DefaultValue || '');
            return foundItem.MasterCustomDataTypeName === 'Date' ? moment(new Date()).format(customFieldInsertionFormat) : (foundItem.DefaultValue || '');
        } else {
            return '';
        }
    }


    useEffect(() => {
        if (AccountEmployeeId === 0 && sessionAccountEmployeeId) {
            dispatch(updateAccountEmployeeId(sessionAccountEmployeeId));
        } else if (AccountEmployeeId > 0) {
            const Decimal = DecimalPlaces;
            getCustomFieldTemplateByMasterEntityTypeIdAsync().then((result) => {
                renderExpenseDropdownFields(Decimal, result);
            }).catch((error) => {
            });
        }

    }, [selectedRecord, AccountExpenseEntryId, AccountEmployeeId, sessionAccountEmployeeId, DecimalPlaces, dispatch]);

    const renderExpenseDropdownFields = async (Decimal: any, customFields: any) => {

        formik.resetForm();
        setApiErrors([]);
        setExpenseValues({
            ...expenseValues,
            isCanvasLoader: true
        })
        const response = await fetchAPI('api/V2/ExpenseSheets/GetAllDataInSingleRequest/' + AccountEmployeeId + '/' + objDefaultValues.AccountClientId + '/' + objDefaultValues.AccountProjectId + '/' + objDefaultValues.AccountExpenseId + '/' + objDefaultValues.AccountPaymentMethodId + '/' + objDefaultValues.AccountCurrencyId + '/' + objDefaultValues.AccountTaxZoneId + '/' + AccountExpenseEntryId, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        if (json["AccountClient"].length > 0) {
            json["AccountClient"].map((item: any) => {
                item.value = item.AccountClientId;
                item.label = item.ClientName;
                delete item.AccountClientId;
                delete item.ClientName;
            });
            json["AccountProject"].map((item: any) => {
                item.value = item.AccountProjectId;
                item.label = item.ProjectName;
                delete item.AccountProjectId;
                delete item.ProjectName;
            });

            json["AccountExpense"].map((item: any) => {
                item.value = item.AccountExpenseId;
                item.label = item.AccountExpenseName;
                delete item.AccountExpenseId;
                delete item.AccountExpenseName;
            });

            json["AccountPaymentMethod"].map((item: any) => {
                item.value = item.AccountPaymentMethodId;
                item.label = item.PaymentMethod;
                delete item.AccountPaymentMethodId;
                delete item.PaymentMethod;
            });
            json["AccountPaymentMethod"].unshift({ value: 0, label: 'None' });


            json["AccountCurrency"].map((item: any) => {
                item.value = item.AccountCurrencyId;
                item.label = item.CurrencyCode;
                delete item.AccountCurrencyId;
                delete item.CurrencyCode;
            });

            json["AccountTaxZone"].map((item: any) => {
                item.value = item.AccountTaxZoneId;
                item.label = item.AccountTaxZone;
                delete item.AccountTaxZoneId;
                delete item.AccountTaxZone;
            });


            if (json["AccountPreferences"].length > 0) {
                const ShowClient = json["AccountPreferences"][0].ShowClientInExpenseSheet
                const ShowTask = json["AccountPreferences"][0].ShowTaskInExpenseSheet
                SetShowClientInExpenseSheet(ShowClient);
                SetShowTaskInExpenseSheet(ShowTask);
            }
            setExpenseResponse({
                ...expenseResponse,
                clients: json["AccountClient"],
                expenses: json["AccountExpense"],
                paymentMethod: json["AccountPaymentMethod"],
                currency: json["AccountCurrency"],
                taxZone: json["AccountTaxZone"],
            })

            if (json["AccountPreferences"][0].ShowClientInExpenseSheet === true) {

                if (AccountExpenseEntryId != 0) {
                    const id: number = json["AccountExpenseEntry"][0].AccountClientId
                    getProjects(id);
                } else {
                    const id: number = json["AccountClient"][0].value
                    getProjects(id);
                }
            } else {
                if (AccountExpenseEntryId != 0) {
                    setProjectValues(json["AccountProject"]);
                } else {
                    setProjectValues(json["AccountProject"]);
                }
            }
            let formattedQuantity
            let formattedRate
            let formattedAmount
            let formattedAmountBeforeTax
            let formattedTaxAmount
            if (AccountExpenseEntryId != 0) {
                const formattedQuantity = formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].Quantity,
                    decimalPlaces
                );
                const formattedRate = formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].Rate,
                    decimalPlaces
                );
                const formattedAmount = formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].Amount,
                    decimalPlaces
                );
                const formattedAmountBeforeTax = formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].AmountBeforeTax,
                    decimalPlaces
                );
                const formattedTaxAmount = formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].AmountBeforeTax,
                    decimalPlaces
                );
            }

const setCustomFieldValues = (customField: string, customFieldData: any, customFields: any) => {
        let foundItem = customFields.find((item: any) => item.DatabaseFieldName === customField);
        
        // Safety check if field definition is not found
        if (!foundItem) return customFieldData;

        if (foundItem.MasterCustomDataTypeName === 'Date') {
            return customFieldData;
        } 
        else if (foundItem.MasterCustomDataTypeName === 'Number') {
            if (customFieldData !== null && customFieldData !== undefined && customFieldData !== '') {
                return formatNumberCustomoriginalapiv2(cultureInfoName.toString(), customFieldData, decimalPlaces);
            }
            return customFieldData;
        } 
        else {
            return customFieldData;
        }
    }

            setExpenseValues({
                ...expenseValues,
                AccountClientId: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].AccountClientId === null ? json["AccountClient"][0].value : json["AccountExpenseEntry"][0].AccountClientId : json["AccountClient"][0].value,
                AccountProjectId: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].AccountProjectId : 0,
                AccountProjectTaskId: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].AccountProjectTaskId : 0,
                AccountExpenseId: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].AccountExpenseId : json["AccountExpense"][0].value,
                AccountPaymentMethodId: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].AccountPaymentMethodId === null ? json["AccountPaymentMethod"][0].value : json["AccountExpenseEntry"][0].AccountPaymentMethodId : json["AccountPaymentMethod"][0].value,
                AccountCurrencyId: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].AccountCurrencyId : accountBaseCurrencyId,
                AccountTaxZoneId: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].AccountTaxZoneId === null ? 0 : json["AccountExpenseEntry"][0].AccountTaxZoneId : json["AccountTaxZone"][0].value,
                // AccountExpenseEntryDate: AccountExpenseEntryId != 0 ? moment(json["AccountExpenseEntry"][0].AccountExpenseEntryDate).toDate() : new Date(),
                AccountExpenseEntryDate: AccountExpenseEntryId != 0 ? dateFormatByAccountCulture(json["AccountExpenseEntry"][0].AccountExpenseEntryDate, cultureInfoName.toString()) : new Date(),
                Amount: AccountExpenseEntryId != 0 ? formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].Amount,
                    decimalPlaces
                ) : 0,
                AmountBeforeTax: AccountExpenseEntryId != 0 ? formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].AmountBeforeTax,
                    decimalPlaces
                ) : 0,
                TaxAmount: AccountExpenseEntryId != 0 ? formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].TaxAmount,
                    decimalPlaces
                ) : '0',
                // Amount: AccountExpenseEntryId != 0 ? formatNumberCustomoriginalapiv2(
                //         cultureInfoName.toString(), 
                //         json["AccountExpenseEntry"][0].Amount, 
                //         decimalPlaces
                //       ) : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces),
                // AmountBeforeTax: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].AmountBeforeTax : 0,
                /*  AmountBeforeTax: AccountExpenseEntryId != 0 ? formatNumberCustomoriginalapiv2(
                         cultureInfoName.toString(), 
                         json["AccountExpenseEntry"][0].AmountBeforeTax, 
                         decimalPlaces
                       ) : 0, */
                //    TaxAmount: 11,
                // TaxAmount: AccountExpenseEntryId != 0 ? formatNumberCustomoriginalapiv2(
                //         cultureInfoName.toString(), 
                //         json["AccountExpenseEntry"][0].AmountBeforeTax, 
                //         decimalPlaces
                //       ) : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces),
                //Quantity: AccountExpenseEntryId != 0 ? parseFloat(json["AccountExpenseEntry"][0].Quantity).toFixed(Decimal) : 0,
                Quantity: AccountExpenseEntryId != 0 ? formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].Quantity,
                    decimalPlaces
                ) : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces),               
                Rate: AccountExpenseEntryId != 0 ? formatNumberCustomoriginalapiv2(
                    cultureInfoName.toString(),
                    json["AccountExpenseEntry"][0].Rate,
                    decimalPlaces
                ) : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), 0, decimalPlaces),
                IsBillable: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].IsBillable : true,
                Reimburse: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].Reimburse : true,
                Submitted: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].Submitted : false,
                Approved: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].Approved : false,
                Rejected: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].Rejected : false,
                Description: AccountExpenseEntryId != 0 ? json["AccountExpenseEntry"][0].Description : '',
                CustomField1: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField1 ? setCustomFieldValues('CustomField1', json["AccountExpenseEntry"][0].CustomField1, customFields) : getDefaultValOfSpecificCustomField('CustomField1', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField1', customFields),

                CustomField2: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField2 ? setCustomFieldValues('CustomField2', json["AccountExpenseEntry"][0].CustomField2, customFields) : getDefaultValOfSpecificCustomField('CustomField2', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField2', customFields),

                CustomField3: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField3 ? setCustomFieldValues('CustomField3', json["AccountExpenseEntry"][0].CustomField3, customFields) : getDefaultValOfSpecificCustomField('CustomField3', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField3', customFields),

                CustomField4: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField4 ? setCustomFieldValues('CustomField4', json["AccountExpenseEntry"][0].CustomField4, customFields) : getDefaultValOfSpecificCustomField('CustomField4', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField4', customFields),

                CustomField5: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField5 ? setCustomFieldValues('CustomField5', json["AccountExpenseEntry"][0].CustomField5, customFields) : getDefaultValOfSpecificCustomField('CustomField5', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField5', customFields),

                CustomField6: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField6 ? setCustomFieldValues('CustomField6', json["AccountExpenseEntry"][0].CustomField6, customFields) : getDefaultValOfSpecificCustomField('CustomField6', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField6', customFields),

                CustomField7: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField7 ? setCustomFieldValues('CustomField7', json["AccountExpenseEntry"][0].CustomField7, customFields) : getDefaultValOfSpecificCustomField('CustomField7', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField7', customFields),

                CustomField8: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField8 ? setCustomFieldValues('CustomField8', json["AccountExpenseEntry"][0].CustomField8, customFields) : getDefaultValOfSpecificCustomField('CustomField8', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField8', customFields),

                CustomField9: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField9 ? setCustomFieldValues('CustomField9', json["AccountExpenseEntry"][0].CustomField9, customFields) : getDefaultValOfSpecificCustomField('CustomField9', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField9', customFields),

                CustomField10: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField10 ? setCustomFieldValues('CustomField10', json["AccountExpenseEntry"][0].CustomField10, customFields) : getDefaultValOfSpecificCustomField('CustomField10', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField10', customFields),

                CustomField11: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField11 ? setCustomFieldValues('CustomField11', json["AccountExpenseEntry"][0].CustomField11, customFields) : getDefaultValOfSpecificCustomField('CustomField11', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField11', customFields),

                CustomField12: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField12 ? setCustomFieldValues('CustomField12', json["AccountExpenseEntry"][0].CustomField12, customFields) : getDefaultValOfSpecificCustomField('CustomField12', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField12', customFields),

                CustomField13: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField13 ? setCustomFieldValues('CustomField13', json["AccountExpenseEntry"][0].CustomField13, customFields) : getDefaultValOfSpecificCustomField('CustomField13', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField13', customFields),

                CustomField14: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField14 ? setCustomFieldValues('CustomField14', json["AccountExpenseEntry"][0].CustomField14, customFields) : getDefaultValOfSpecificCustomField('CustomField14', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField14', customFields),

                CustomField15: AccountExpenseEntryId != 0 ?
                    (json["AccountExpenseEntry"][0].CustomField15 ? setCustomFieldValues('CustomField15', json["AccountExpenseEntry"][0].CustomField15, customFields) : getDefaultValOfSpecificCustomField('CustomField15', customFields)) :
                    getDefaultValOfSpecificCustomField('CustomField15', customFields),
                isCanvasLoader: false
            });


            if (AccountExpenseEntryId != 0) {
                const AccountProjectId = json["AccountExpenseEntry"][0].AccountProjectId
                getTasks(AccountProjectId);
            }

            const LockSubmittedRecord = json["AccountPreferences"][0].LockSubmittedRecords;
            const LockApprovedRecord = json["AccountPreferences"][0].LockApprovedRecords;
            const DecimalPlaces = json["AccountPreferences"][0].DecimalPlaces;
            dispatch(setPreferenceOptions({ LockSubmittedRecord, LockApprovedRecord, DecimalPlaces }));
            if (AccountExpenseEntryId != 0) {
                const AccountExpenseId = json["AccountExpenseEntry"][0].AccountExpenseId
                ShowHideFields(AccountExpenseId);
                setExpenseId(AccountExpenseId);
                setApiErrors([]);
                setistaxzoneid(json["AccountExpenseEntry"][0].AccountTaxZoneId === null ? 0 : json["AccountExpenseEntry"][0].AccountTaxZoneId);
            } else {
                const value = json["AccountExpense"][0].value;
                ShowHideFields(value);
                setTaskArray([]);
                setExpenseId(value);
                setistaxzoneid(json["AccountTaxZone"][0].value);
            }
        }
    }


    const getProjects = async (id: number) => {

        const AccountClientId = value
        if (id > 0) {
            const response = await fetchAPI('api/V2/ExpenseSheets/GetAccountProjectsByClient/' + id + '/' + AccountEmployeeId + '/' + objDefaultValues.AccountProjectId, "GET", "", true);
            const json = await response.json();
            json.map((item: any) => {
                item.value = item.AccountProjectId;
                item.label = item.ProjectName;
                delete item.AccountProjectId;
                delete item.ProjectName;
            });
            setProjectValues(json)
        }

    }

    const getTasks = async (value: any) => {
        const AccountProjectId = value
        const response = await fetchAPI('api/V2/ExpenseSheets/GetAccountProjectTasksByProject/' + AccountProjectId + '/' + AccountEmployeeId + '/' + 0, "GET", "", true, "d8667f9b-57fd-4ca8-9496-59cbebb5f944");
        const json = await response.json();
        const TaskData = json.map((item: any) => ({
            value: item.AccountProjectTaskId,
            label: item.TaskName
        }));
        setTaskArray(TaskData);
    }
    const getFormattedCustomField = (fieldName: string, value: any) => {
        const field = customFieldsArray.find((item: any) => item.DatabaseFieldName === fieldName);
        // If field exists, is type Number, and has a value
        if (field && field.MasterCustomDataTypeName === 'Number' && value) {
            return value.toString().replace(',', '.');
        }
        return value;
    };

    const handleSubmit = async (values: any) => {
        // const valid = await checkValidation();
        // if (valid[0].message != "true") {
        //     alert(valid);
        //     return;        
        // }
        // if (valid[1].message != "true") {
        //     alert(valid);
        //     return;
        // }
        // if (valid[2].message != "true") {
        //     alert(valid);
        //     return;
        // }   
        const valid = await checkValidation();

        // Initialize an array to collect validation messages
        const validationErrors: any = {};

        if (valid && valid.length > 0) {
            // Check validation messages
            for (let i = 0; i < valid[0].length; i++) {
                if (valid[0][i].message != "true") {

                    validationErrors[`field${i}`] = valid[0][i].message; // Adjust field name as necessary

                }
            }

            // If there are validation errors, set them in Formik
            if (Object.keys(validationErrors).length > 0) {
                formik.setErrors(validationErrors);
                return; // Prevent form submission
            }
        }

        if (AccountExpenseEntryId > 0) {
            /* const formattedValues = {
                ...values,
                AccountExpenseEntryDate: moment(values.AccountExpenseEntryDate).format(dateInsertionFormat)
            }; */
            const formattedValues = {
                ...values,
                AccountExpenseEntryDate: moment(values.AccountExpenseEntryDate).format(dateInsertionFormat),
                Amount: parseLocalizedNumber(values.Amount),
                AmountBeforeTax: parseLocalizedNumber(values.AmountBeforeTax),
                Quantity: parseLocalizedNumber(values.Quantity),
                Rate: parseLocalizedNumber(values.Rate),
                TaxAmount: parseLocalizedNumber(values.TaxAmount),
                CustomField1: getFormattedCustomField('CustomField1', values.CustomField1),
                CustomField2: getFormattedCustomField('CustomField2', values.CustomField2),
                CustomField3: getFormattedCustomField('CustomField3', values.CustomField3),
                CustomField4: getFormattedCustomField('CustomField4', values.CustomField4),
                CustomField5: getFormattedCustomField('CustomField5', values.CustomField5),
                CustomField6: getFormattedCustomField('CustomField6', values.CustomField6),
                CustomField7: getFormattedCustomField('CustomField7', values.CustomField7),
                CustomField8: getFormattedCustomField('CustomField8', values.CustomField8),
                CustomField9: getFormattedCustomField('CustomField9', values.CustomField9),
                CustomField10: getFormattedCustomField('CustomField10', values.CustomField10),
                CustomField11: getFormattedCustomField('CustomField11', values.CustomField11),
                CustomField12: getFormattedCustomField('CustomField12', values.CustomField12),
                CustomField13: getFormattedCustomField('CustomField13', values.CustomField13),
                CustomField14: getFormattedCustomField('CustomField14', values.CustomField14),
                CustomField15: getFormattedCustomField('CustomField15', values.CustomField15),

            };
            dispatch(updateAccountExpenseEntryAsync(formattedValues))
                .unwrap()
                .then((originalPromiseResult) => {
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    ShowToast('Expense Entry Successfully Update', 'Success', "success", "toast-top-right")
                    dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(AccountEmployeeExpenseSheetId));

                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            if (AccountEmployeeExpenseSheetId !== '') {

                const formattedValues = {
                    ...values,
                    Amount: parseLocalizedNumber(values.Amount),
                    AmountBeforeTax: parseLocalizedNumber(values.AmountBeforeTax),
                    Quantity: parseLocalizedNumber(values.Quantity),
                    Rate: parseLocalizedNumber(values.Rate),
                    TaxAmount: parseLocalizedNumber(values.TaxAmount),
                CustomField1: getFormattedCustomField('CustomField1', values.CustomField1),
                CustomField2: getFormattedCustomField('CustomField2', values.CustomField2),
                CustomField3: getFormattedCustomField('CustomField3', values.CustomField3),
                CustomField4: getFormattedCustomField('CustomField4', values.CustomField4),
                CustomField5: getFormattedCustomField('CustomField5', values.CustomField5),
                CustomField6: getFormattedCustomField('CustomField6', values.CustomField6),
                CustomField7: getFormattedCustomField('CustomField7', values.CustomField7),
                CustomField8: getFormattedCustomField('CustomField8', values.CustomField8),
                CustomField9: getFormattedCustomField('CustomField9', values.CustomField9),
                CustomField10: getFormattedCustomField('CustomField10', values.CustomField10),
                CustomField11: getFormattedCustomField('CustomField11', values.CustomField11),
                CustomField12: getFormattedCustomField('CustomField12', values.CustomField12),
                CustomField13: getFormattedCustomField('CustomField13', values.CustomField13),
                CustomField14: getFormattedCustomField('CustomField14', values.CustomField14),
                CustomField15: getFormattedCustomField('CustomField15', values.CustomField15),
                AccountExpenseEntryDate: moment(values.AccountExpenseEntryDate).format(dateInsertionFormat)

                };

                dispatch(addAccountExpenseEntryAsync({ ...formattedValues, 'AccountEmployeeExpenseSheetId': AccountEmployeeExpenseSheetId, 'AccountEmployeeId': AccountEmployeeId }))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        const requestId = originalPromiseResult.Data[0].AccountExpenseEntryId;
                        tempAttachmentId != null && dispatch(addAttachment({ Id: requestId, IsEdit: false, tempAttachmentId: tempAttachmentId, AccountAttachmentTypeId: 1 }))
                        ShowToast('Expense Entry Successfully Inserted', 'Success', "success", "toast-top-right")
                        dispatch(getExpenseEntriesByAccountEmployeeExpenseSheetIdAsync(AccountEmployeeExpenseSheetId));

                    })
                    .catch((rejectedValueOrSerializedError) => {
                        ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    })
            }
            else {
                const formattedValues = {
                    ...values,
                    Amount: parseLocalizedNumber(values.Amount),
                    AmountBeforeTax: parseLocalizedNumber(values.AmountBeforeTax),
                    Quantity: parseLocalizedNumber(values.Quantity),
                    Rate: parseLocalizedNumber(values.Rate),
                    TaxAmount: parseLocalizedNumber(values.TaxAmount),
                    AccountExpenseEntryDate: moment(values.AccountExpenseEntryDate).format(dateInsertionFormat)

                };

                dispatch(addAccountEmployeeExpenseSheetAsync({ SheetDate: expensesheetDate, SheetDescription: expenseSheetDescription, SheetEmployeeId: AccountEmployeeId, SheetReimburseCurrency: reimburseCurrencyId }))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        dispatch(updateMasterExpenseSheetId(originalPromiseResult.id));
                        updateMasterIdInState(originalPromiseResult.id);
                        dispatch(addAccountExpenseEntryAsync({ ...formattedValues, 'AccountEmployeeExpenseSheetId': originalPromiseResult.id, 'AccountEmployeeId': AccountEmployeeId }))
                            .unwrap()
                            .then((originalPromiseResult) => {
                                const requestId = originalPromiseResult.Data[0].AccountExpenseEntryId;
                                tempAttachmentId != null && dispatch(addAttachment({ Id: requestId, IsEdit: false, tempAttachmentId: tempAttachmentId, AccountAttachmentTypeId: 1 }))
                                ShowToast('Expense Entry Successfully Inserted', 'Success', "success", "toast-top-right");
                            })
                            .catch((rejectedValueOrSerializedError) => {
                                ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                            })
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    })
            }
        }
        formik.resetForm();
        if (closeButtonRef1.current) {
            closeButtonRef1.current.click();
        }
    }

    const handleCloseOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        // dispatch(resetSelectedRecordObjectInState());

    }

    const handleChangeClient = (data: any) => {
        const { value, label } = data;
        setSelectedClient({ value: value, label: label });
        getProjects(value);
    }
    const handleChangeProject = (data: any) => {
        const { value, label } = data;
        setSelectedProject({ value: value, label: label });
        getTasks(value);
    }

    const ShowHideFields = (ExpenseType: any) => {

        dispatch(getCalculationsFieldsByAccountExpenseIdAsync(ExpenseType))
            .unwrap()
            .then((originalPromiseResult) => {

                setShowQuantity(originalPromiseResult[0].ShowQuantity);
                setShowNetAmount(originalPromiseResult[0].ShowNetAmount);
                setShowRate(originalPromiseResult[0].ShowRate);
                setShowTax(originalPromiseResult[0].ShowTaxCode);
                setShowTaxZone(originalPromiseResult[0].ShowTaxZone);
            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('handleSubmit-updateAccountExpensePolicyRulesAsync-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
            })
    }



    const debouncedHandleChange = (id: string, e: any) => {
        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }

        typingTimeoutRef.current = setTimeout(() => {
            handleChange(id, e);
        }, 800);
    };

    const handleChange = async (id: string, e: any) => {

        const { value } = e.target;
        const regex = /^[0-9]*\.?[0-9]*$/;
        formik.setFieldValue(id, value);

        /*         if (regex.test(value)) {
                    formik.setFieldValue(id, value);
                } */

        if (typingTimeoutRef.current) {
            clearTimeout(typingTimeoutRef.current);
        }

        typingTimeoutRef.current = setTimeout(async () => {
            const currentValue = e.target.value;
            if (id !== 'Amount') {
                setId(id);
                setvalue(currentValue);
            }

            //if (id === 'Amount' || id === 'AmountBeforeTax') {
            if (id === 'Amount' || id === 'AmountBeforeTax') {
                const validationResponse: any = await limitvalidations(currentValue);

                if (validationResponse && validationResponse.Data && Array.isArray(validationResponse.Data)) {
                    const newApiErrors = validationResponse.Data
                        .filter((item: any) => item.message !== 'true')
                        .map((item: any) => item.message);
                    setApiErrors(newApiErrors);

                    if (newApiErrors.length > 0) {
                    } else {
                        formik.setFieldError('Amount', undefined);
                    }
                } else {

                }
            }
        }, 1000);
    };

    
    const handleChange1 = async (id: string, e: any) => {
        const { value } = e.target;
        const regex = /^[0-9]*\.?[0-9]*$/;

        if (regex.test(value)) {
            formik.setFieldValue(id, value);
        }
        if (id !== 'Amount') {
            setId(id);
            setvalue(value);
        }
        if (id === 'Amount' || id === 'AmountBeforeTax') {
            const validationResponse: any = await limitvalidations(value);
            if (validationResponse && validationResponse.Data && Array.isArray(validationResponse.Data)) {
                const newApiErrors = validationResponse.Data
                    .filter((item: any) => item.message !== 'true')
                    .map((item: any) => item.message);
                setApiErrors(newApiErrors);
                if (newApiErrors.length > 0) {
                } else {
                    formik.setFieldError('Amount', undefined);
                }
            } else {
            }
        }
    }

    useEffect(() => {

        if (id !== 'AccountTaxZoneId') {
            if (id && value) {
                CalculationsByExpense(id, formik.values[id]);
            }
        }
    }, [id, value])

    const CalculationsByExpense = (controlId: any, value: any) => {
        var isUserChanged = false;
        var isUserTaxAmount = false;
        var isChangedNetAmount = false;
        var doCalculation = false;
        if (controlId !== "") {
            if (controlId === 'Quantity' || controlId === 'AccountTaxZoneId' || controlId === 'Rate' || controlId === 'AmountBeforeTax' || controlId === 'Amount' || controlId === 'Tax') {
                doCalculation = true;
            }
            if (controlId === 'AmountBeforeTax' && value !== null && value !== '') {
                isChangedNetAmount = true;
            }
            if (controlId === 'Tax' && value !== null) {
                isUserTaxAmount = true;
                isChangedNetAmount = true;
            }
            if (controlId === 'AccountTaxZoneId' && value !== null) {
                isChangedNetAmount = true;
            }
        }

        var ExpenseId = expenseValues.AccountExpenseId;

        var quantity = 0, rate = 0, taxAmount = 0.00, amount = 0.00, netAmount = 0.00, expenseEntryId = 0;


        if (formik.values.Quantity !== null) {
            quantity = (formik.values.Quantity !== undefined ? formik.values.Quantity : 0);
        }
        if (formik.values.Rate !== null) {
            rate = (formik.values.Rate !== undefined ? formik.values.Rate : 0);
        }
        if (formik.values.Tax !== null) {
            taxAmount = (formik.values.Tax !== undefined ? formik.values.Tax : 0);
        }

        if (formik.values.AmountBeforeTax !== null) {
            netAmount = (formik.values.AmountBeforeTax !== undefined ? formik.values.AmountBeforeTax : 0);

        }

        if (formik.values.Amount !== null) {
            amount = (formik.values.Amount !== undefined ? formik.values.Amount : 0);
            setFinalAmount(amount);
        }

        var taxZoneId = istaxzone;
        if (controlId === 'AccountTaxZoneId' && value !== null) {
            taxZoneId = value;
        }
        let strForQuantity
        let strForRate
        let strForTaxAmount
        let strForNetAmount
        let strForAmount
        let parsedQuantity
        let parsedRate
        let parsedTaxAmount
        let parsedNetAmount
        let parsedAmount
        const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
        if (isCommaSeparator) {
            strForTaxAmount = String(taxAmount).replace(',', '.');
            strForNetAmount = String(netAmount).replace(',', '.');
            strForQuantity = String(quantity).replace(',', '.');
            strForRate = String(rate).replace(',', '.');
            strForAmount = String(amount).replace(',', '.');
            parsedQuantity = parseFloat(strForQuantity)
            parsedRate = parseFloat(strForRate)
            parsedAmount = parseFloat(strForAmount)
            parsedNetAmount = parseFloat(strForNetAmount)
            parsedTaxAmount = parseFloat(strForTaxAmount)

        }
        if (isCommaSeparator === false) {

            if (formik.values.Amount !== null) {

            }
            strForTaxAmount = taxAmount;
            strForNetAmount = netAmount;
            strForQuantity = quantity;
            strForRate = rate;
            strForAmount = amount;
            parsedQuantity = quantity;
            parsedRate = rate;
            parsedAmount = amount;
            parsedNetAmount = netAmount;
            parsedTaxAmount = taxAmount;
        }
        dispatch(GetExpenseCalculateAmountAsync({ decimalPlaces, cultureInfoName, ExpenseId, taxZoneId, parsedNetAmount, parsedAmount, isUserChanged, isUserTaxAmount, isChangedNetAmount, parsedQuantity, parsedRate, parsedTaxAmount }))
            .unwrap()
            .then((originalPromiseResult) => {
                setExpenseValues({
                    ...formik.values,
                    //'TaxAmount': originalPromiseResult.Data.TaxAmount,
                    'TaxAmount': formatNumberCustomoriginalapiv2(cultureInfoName.toString(), originalPromiseResult.Data.TaxAmount, decimalPlaces),
                    //'Amount': originalPromiseResult.Data.Amount,
                    'Amount': formatNumberCustomoriginalapiv2(cultureInfoName.toString(), originalPromiseResult.Data.Amount, decimalPlaces),
                    //'AmountBeforeTax': originalPromiseResult.Data.NetAmount,
                    'AmountBeforeTax': originalPromiseResult.Data.NetAmount % 1 === 0
                        ? originalPromiseResult.Data.NetAmount.toString() : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), originalPromiseResult.Data.NetAmount, decimalPlaces),
                        'Quantity': originalPromiseResult.Data.Quantity % 1 === 0
                        ? originalPromiseResult.Data.Quantity.toString() : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), originalPromiseResult.Data.Quantity, decimalPlaces),                       
                    'AccountTaxZoneId': taxZoneId                   
                });

            })
            .catch((rejectedValueOrSerializedError) => {
                console.log('Error Expense Calculate Amount', rejectedValueOrSerializedError);
            })
    };



    const onChange = (data: any, filterName: any, tempClientId: number = 0) => {
        setExpenseValues({
            ...expenseValues,
            AccountClientId: filterName.name == "clientslist" ? expenseResponse.clients.filter((x: any) => x.value == data.value)[0].value : (tempClientId != 0 ? tempClientId : expenseValues.AccountClientId),
            AccountProjectId: filterName.name == "projectslist" ? projectValues.filter((x: any) => x.value == data.value)[0].value : expenseValues.AccountProjectId,
            AccountPaymentMethodId: filterName.name == "expenseMethodlist" ? expenseResponse.paymentMethod.filter((x: any) => x.value == data.value)[0].value : expenseValues.AccountPaymentMethodId,
            AccountCurrencyId: filterName.name == "currencylist" ? expenseResponse.currency.filter((x: any) => x.value == data.value)[0].value : expenseValues.AccountCurrencyId,
        });

        if (filterName.name == "clientslist") {
            objDropdown.projects = [];
            getProjects(data.value);
        }
        if (filterName.name == "projectslist") {
            objDropdown.projectTask = [];
            getTasks(data.value);
        }

        if (filterName.name == "expenseslist") {
            const { value, label } = data;
            setExpenseId(value);
            ShowHideFields(value);
            dispatch(SetDefaultExpenseRateAsync(data.value))
                .unwrap()
                .then((originalPromiseResult) => {
                    const updatedValues = {
                        ...formik.values,
                        AccountExpenseId: data.value,
                        //Rate: originalPromiseResult[0].Rate === null ? 0 : originalPromiseResult[0].Rate,
                        Rate: originalPromiseResult[0].Rate === null ? 0 : formatNumberCustomoriginalapiv2(cultureInfoName.toString(), originalPromiseResult[0].Rate, decimalPlaces),
                        Quantity: 0,
                        AmountBeforeTax: 0,
                        Amount: 0,
                    };

                    setExpenseValues(updatedValues);
                    formik.setValues(updatedValues);
                    // setExpenseValues({
                    //     ...formik.values,
                    //     'Rate': originalPromiseResult[0].Rate === null ? 0 : originalPromiseResult[0].Rate,
                    //     //'AccountTaxZoneId': originalPromiseResult[0].AccountTaxZoneId,
                    //     'Quantity': 0,
                    //     // 'Tax': 0,
                    //     'AmountBeforeTax': 0,
                    //     'Amount': 0,
                    //     AccountExpenseId: data.value
                    // });
                })
                .catch((rejectedValueOrSerializedError) => {
                    console.log('Error', rejectedValueOrSerializedError);
                })
        }

        if (filterName.name == "taxZonelist") {
            const { value, label } = data;
            setExpenseValues({ ...expenseValues, 'AccountTaxZoneId': value });
            setistaxzoneid(value);
            CalculationsByExpense('AccountTaxZoneId', value);
        }

    };

    const handleCombinedChange = (selectedProject: any, filter: any) => {
        // formik.setFieldValue(filter.name, selectedProject?.value || 0);
        // formik.setFieldTouched(filter.name, true);

        formik.setFieldValue(filter.name, selectedProject?.value || 0, false); // Prevent validation
        formik.setFieldTouched(filter.name, false);


        const AccountClient = projectValues.find((x: any) => x.value === selectedProject?.value);
        if (AccountClient) {
            setExpenseValues((prevExpenseValues: any) => ({
                ...prevExpenseValues,
                AccountClientId: AccountClient.AccountClientId
            }));
        }
        onChange(selectedProject, filter, AccountClient.AccountClientId);
    };


    const onSwitch = (data: any) => {
        let switchName = data.target.name;
        setExpenseValues({
            ...formik.values,
            IsBillable: switchName == "IsBillable" ? expenseValues.IsBillable ? false : true : expenseValues.IsBillable,
            Reimburse: switchName == "Reimburse" ? expenseValues.Reimburse ? false : true : expenseValues.Reimburse
        });
    }


    const updateTempAttachmentId = (value: any) => {
        setTempAttachmentId(value);
    }

    const clearAttachmentUpload = () => {
        if (attachmentUploadClearRef.current) {
            attachmentUploadClearRef.current();
        }
    }

    const onDateChange = (date: any, name: any) => {
        setExpenseValues({
            ...formik.values,
            AccountExpenseEntryDate: name == "AccountExpenseEntryDate" ? date : expenseValues.AccountExpenseEntryDate
        });
    }

    const onCustomFieldChange = (name: string, value: any) => {
        setExpenseValues({
            ...formik.values,
            [name]: value
        });
    }

    const handleBlurValidateAll = () => {
        // Mark all fields as touched
        Object.keys(formik.values).forEach(field => {
            formik.setFieldTouched(field, true);
        });

        // Validate all fields
        formik.validateForm();
    };

    //  const description = formik.values.Description; // Replace with appropriate ref or state
    const checkValidation = async () => {

        const isDescription = formik.values.Description.length > 0;
        let hasFile = false;
        let isValided = false;
        try {

            let strForAmount
            let parsedAmount
            const isCommaSeparator = determineCommaSeprater(cultureInfoName.toString());
            if (isCommaSeparator) {
                strForAmount = String(formik.values.Amount).replace(',', '.');
                parsedAmount = parseFloat(strForAmount) || 0
            }
            //const response = await fetchAPI('api/v2/ExpenseSheets/CheckAllow/' + MasterEntityTypeId, 'GET', '', true, "");
            const response = await fetchAPI(`api/v2/ExpenseSheets/CheckAllow/${AccountEmployeeId}/${expenseValues.AccountExpenseId}/${parsedAmount}/${isDescription}/${hasFile}/`, 'GET', '', true, "");
            const data = await response.json();

            const newMessages: any = [];
            if (data.Data[0].message !== "true") {
                isValided = true;
                newMessages.push(data.Data);
            }
            if (data.Data[1].message !== "true") {
                isValided = true;
                newMessages.push(data.Data);
            }
            if (data.Data[2].message !== "true") {
                isValided = true;
                newMessages.push(data.Data);
            }

            setMessages(newMessages);
            return newMessages;
        } catch (error: any) {
            console.error("Error fetching data:", error);
            // Handle error as needed
            return null;
        }
    };

    useEffect(() => {
        if (Object.entries(selectedRecord).length == 0 && !ShowTax && formik.values.TaxAmount && formik.values.TaxAmount !== 0) {
            formik.setValues({ ...formik.values, TaxAmount: 0, Amount: 0 });
            setTaxAmount('');
        }
        if (Object.entries(selectedRecord).length == 0 && !ShowNetAmount && formik.values.AmountBeforeTax && formik.values.AmountBeforeTax !== 0) {
            formik.setValues({ ...formik.values, TaxAmount: 0, AmountBeforeTax: 0 });
            setTaxAmount('');
        }
    }, [ShowTax, formik.values.AmountBeforeTax]);

    return (
        <>
            <div className='card-body' style={{ marginTop: '-30px' }}>

                {expenseValues.isCanvasLoader ? <CanvasLoader /> : <>
                    <div className='card-header' style={{ marginLeft: '-30px' }}>
                        <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap mt-4' role='tablist'>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Basic' })}
                                    onClick={() => setTab('Basic')}
                                    role='tab'
                                >
                                    {/* {t('Basic')} */}
                                    {getValueFromResource('Basic', dispatch, t)}

                                </a>
                            </li>
                            <li className='nav-item'>
                                <a
                                    className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Description' })}
                                    onClick={() => setTab('Description')}
                                    role='tab'
                                >
                                    {/* {t('Description')} */}
                                    {getValueFromResource('Description', dispatch, t)}

                                </a>
                            </li>
                            {enableUploadFeature &&
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'Attachment' })}
                                        onClick={() => setTab('Attachment')}
                                        role='tab'
                                    >
                                        {/* {t('Attachment')} */}
                                        {getValueFromResource('Attachment', dispatch, t)}

                                    </a>
                                </li>}
                            {customFieldsArray && customFieldsArray.length > 0 &&
                                <li className='nav-item'>
                                    <a
                                        className={clsx(`nav-link cursor-pointer tabFontWeight`, { active: tab === 'CustomField' })}
                                        onClick={() => setTab('CustomField')}
                                        role='tab'
                                    >
                                        {/* {t('Custom Field')} */}
                                        {getValueFromResource('Custom Field', dispatch, t)}

                                    </a>
                                </li>
                            }
                        </ul>
                    </div>
                    <div className='tab-content pt-6'>
                        <div className={clsx('tab-pane', { active: tab === 'Basic' })}>
                            <div className='row'>
                                {showClientInExpenseSheet && (
                                    <div className="col-md-6 mb-2">
                                        <label className="fs-7 fw-normal mb-2">
                                            {/* {t('Client Name')} */}
                                            {getValueFromResource('Client Name', dispatch, t)}
                                        </label>
                                        <Select
                                            value={expenseResponse.clients.filter((x: any) => x.value == expenseValues.AccountClientId)}
                                            className="basic-single fs-7 fw-normal"
                                            classNamePrefix="select"
                                            name="clientslist"
                                            onChange={(e, name) => onChange(e, name)}
                                            options={expenseResponse.clients}
                                            styles={dropDownSelectionStyles}
                                            maxMenuHeight={maxMenuHeight}

                                        />
                                    </div>
                                )}
                                <div className="col-md-6 mb-2">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t('Project Name')} */}
                                        {getValueFromResource('Project Name', dispatch, t)}
                                    </label>
                                    <Select
                                        value={projectValues.find((x: any) => x.value === formik.values.AccountProjectId) || null}
                                        className="basic-single fs-7 fw-normal"
                                        classNamePrefix="select"
                                        name="projectslist"
                                        //onBlur={() => formik.setFieldTouched('AccountProjectId', true)}
                                        //onBlur={() => handleBlurValidateAll()}
                                        onChange={(e, name) => handleCombinedChange(e, name)}
                                        options={projectValues}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />
                                    <div style={{ paddingRight: 20 }}>
                                        {formik.touched.AccountProjectId && formik.errors.AccountProjectId && (
                                            <p className='errorMsg'>{formik.errors.AccountProjectId as string}</p>
                                        )}
                                    </div>

                                </div>

                                {showTaskInExpenseSheet && (
                                    <div className="col-md-6 mb-2">
                                        <label className="fs-7 fw-normal mb-2">
                                            {/* {t('Task Name')} */}
                                            {getValueFromResource('Task Name', dispatch, t)}
                                        </label>
                                        <Select
                                            value={taskArray.find((option: any) => option.value == formik.values.AccountProjectTaskId)}
                                            id="AccountProjectTaskId"
                                            className="basic-single fs-7 fw-normal"
                                            classNamePrefix="select"
                                            isSearchable={true}
                                            name="AccountProjectTaskId"
                                            onBlur={() => formik.setFieldTouched('AccountProjectTaskId', true)}
                                            onChange={(selectedTask: any) => {
                                                formik.handleChange({
                                                    target: {
                                                        id: "AccountProjectTaskId",
                                                        value: selectedTask?.value
                                                    },
                                                });
                                            }}
                                            options={taskArray}
                                            styles={dropDownSelectionStyles}
                                            maxMenuHeight={maxMenuHeight}
                                        />
                                    </div>
                                )}

                                <div className="col-md-6 mb-2">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t('Expense Name')} */}
                                        {getValueFromResource('Expense Name', dispatch, t)}
                                    </label>
                                    <Select
                                        value={expenseResponse.expenses.filter((x: any) => x.value == expenseValues.AccountExpenseId)}
                                        className="basic-single fs-7 fw-normal"
                                        classNamePrefix="select"
                                        name="expenseslist"
                                        onChange={(e, name) => onChange(e, name)}
                                        options={expenseResponse.expenses}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />
                                </div>

                                <div className="col-md-6 mb-2">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t('Payment Method')} */}
                                        {getValueFromResource('Payment Method', dispatch, t)}
                                    </label>
                                    <Select
                                        value={expenseResponse.paymentMethod.filter((x: any) => x.value == expenseValues.AccountPaymentMethodId)}
                                        className="basic-single fs-7 fw-normal"
                                        classNamePrefix="select"
                                        name="expenseMethodlist"
                                        onChange={(e, name) => onChange(e, name)}
                                        options={expenseResponse.paymentMethod}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />
                                </div>

                                <div className="col-md-6 mb-2">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t('Currency')} */}
                                        {getValueFromResource('Currency', dispatch, t)}
                                    </label>
                                    <Select
                                        value={expenseResponse.currency.filter((x: any) => x.value == expenseValues.AccountCurrencyId)}
                                        className="basic-single fs-7 fw-normal"
                                        classNamePrefix="select"
                                        name="currencylist"
                                        onChange={(e, name) => onChange(e, name)}
                                        options={expenseResponse.currency}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />
                                </div>
                                <div className="col-md-6 mb-2">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`Entry Date`)} */}
                                        {getValueFromResource('Entry Date', dispatch, t)}
                                    </label>
                                    <div className="wrapper">
                                        <DatePicker selected={expenseValues.AccountExpenseEntryDate}
                                            calendarStartDay={calendarStartDay}
                                            onChange={(date) => onDateChange(date, "AccountExpenseEntryDate")}
                                            className="form-control dataPicker form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                            dateFormat={CurrentCultureDateFormat.toString()}>
                                        </DatePicker>
                                        <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                    </div>
                                </div>

                                <div className="col-md-6 mb-2">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`Billable`)} */}
                                        {getValueFromResource('Billable', dispatch, t)}
                                    </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">

                                        <input
                                            id="IsBillable"
                                            name="IsBillable"
                                            className="form-check-input h-20px w-30px mt-2"
                                            type="checkbox"
                                            checked={expenseValues.IsBillable}
                                            onChange={(e) => { onSwitch(e) }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 mb-2">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`Reimburse`)} */}
                                        {getValueFromResource('Reimburse', dispatch, t)}
                                    </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input
                                            id="Reimburse"
                                            name="Reimburse"
                                            className="form-check-input h-20px w-30px mt-2"
                                            type="checkbox"
                                            checked={expenseValues.Reimburse}
                                            onChange={(e) => { onSwitch(e) }}
                                        />
                                    </div>
                                </div>

                                {ShowQuantity && (
                                    <div className="col-md-6 mb-2">
                                        <label className="fs-7 fw-normal mb-2">
                                            {/* {t(`Quantity`)} */}
                                            {getValueFromResource('Quantity', dispatch, t)}
                                        </label>
                                        <input type="text" className="form-control fs-7 fw-normal" id='Quantity' name="Quantity"
                                            value={formik.values.Quantity}
                                            //onChange={(e) => handleChange('Quantity', e)}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                                    formik.setFieldValue('Quantity', val);
                                                    handleChange('Quantity', e);
                                                }

                                                
                                            }}                                          


                                        />
                                        <div style={{ paddingRight: 20 }}>
                                            {formik.touched.Quantity && formik.errors.Quantity && (
                                                <p className='errorMsg'>{formik.errors.Quantity as string}</p>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {ShowRate && (
                                    <div className="col-md-6 mb-2">
                                        <label className="fs-7 fw-normal mb-2">
                                            {/* {t(`Rate`)} */}
                                            {getValueFromResource('Rate', dispatch, t)}
                                        </label>
                                        <input type="text" className="form-control fs-7 fw-normal"
                                            id='Rate'
                                            value={formik.values.Rate}
                                            name='Rate'
                                            //onChange={(e) => handleChange('Rate', e)}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (validateCultureNumber(val, cultureInfoName.toString(), decimalPlaces)) {
                                                    handleChange('Rate', e);
                                                }
                                                //formik.setFieldValue('Rate', val);       

                                            }}
                                            onBlur={(e) => {
                                                ///const val: any = parseFloat(e.target.value).toFixed(DecimalPlaces);
                                                //formik.setFieldValue('Rate', isNaN(val) ? '0' : val);
                                                const formatted = formatNumberCustomoriginal(
                                                    cultureInfoName.toString(),
                                                    formik.values.Rate,
                                                    decimalPlaces
                                                );
                                                formik.setFieldValue('Rate', formatted);
                                            }
                                            }
                                        />
                                        <div style={{ paddingRight: 20 }}>
                                            {formik.touched.Rate && formik.errors.Rate && (
                                                <p className='errorMsg'>{formik.errors.Rate as string}</p>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {ShowNetAmount && (
                                    <div className="col-md-6 mb-2">
                                        <label className="fs-7 fw-normal mb-2">
                                            {getValueFromResource('Net Amount', dispatch, t)}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control fs-7 fw-normal"
                                            id='AmountBeforeTax'
                                            value={formik.values.AmountBeforeTax}
                                            name='AmountBeforeTax'
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                const isUSCulture = cultureInfoName.toString();

                                                if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                     formik.setFieldValue('AmountBeforeTax', value);
                                                     handleChange('AmountBeforeTax', e);
                                                }
                                            }}
                                            onBlur={(e) => {
                                                 const formatted = formatNumberCustomoriginal(                                                    
                                                    cultureInfoName.toString(),
                                                    e.target.value,
                                                    DecimalPlaces
                                                );
                                                formik.setFieldValue('AmountBeforeTax', formatted);
                                                handleChange('AmountBeforeTax', e);
                                            }}
                                        />
                                        <div style={{ paddingRight: 20 }}>
                                            {formik.touched.AmountBeforeTax && formik.errors.AmountBeforeTax && (
                                                <p className='errorMsg'>{formik.errors.AmountBeforeTax as string}</p>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {ShowTaxZone && (
                                    <div className="col-md-6 mb-2">
                                        <label className="fs-7 fw-normal mb-2">
                                            {/* {t(`Tax Zone`)} */}
                                            {getValueFromResource('Tax Zone', dispatch, t)}
                                        </label>
                                        <Select
                                            value={expenseResponse.taxZone.filter((x: any) => x.value == expenseValues.AccountTaxZoneId)}
                                            className="basic-single fs-7 fw-normal"
                                            classNamePrefix="select"
                                            name="taxZonelist"
                                            onChange={(e, name) => onChange(e, name)}
                                            options={expenseResponse.taxZone}
                                            styles={dropDownSelectionStyles}
                                            maxMenuHeight={maxMenuHeight}
                                            menuPlacement="auto"
                                            menuPosition="fixed"
                                        />
                                    </div>
                                )}
                                {ShowTax && (
                                    <div className="col-md-6 mb-2">
                                        <label className="fs-7 fw-normal mb-2">
                                            {/* {t(`Tax`)} */}
                                            {getValueFromResource('Tax', dispatch, t)}
                                        </label>
                                        <input type="text" className="form-control fs-7 fw-normal" id='Tax'
                                            value={formik.values.TaxAmount}
                                            name='Tax'

                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value === '') {
                                                    formik.setFieldValue('TaxAmount', '');
                                                    return;
                                                }
                                                if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                    formik.setFieldValue('TaxAmount', value);
                                                    handleChange('Tax', e);
                                                }
                                            }}
                                            onBlur={(e) => {
                                                const value = e.target.value.trim();
                                                if (value === '' || value === null || value === undefined) {

                                                    return;
                                                }

                                                const formatted = formatNumberCustomoriginal(
                                                    cultureInfoName.toString(),
                                                    value,
                                                    decimalPlaces
                                                );

                                                formik.setFieldValue('TaxAmount', formatted);
                                            }}

                                        />
                                    </div>
                                )}

                                <div className="col-md-6 mb-2">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`Amount`)} */}
                                        {getValueFromResource('Amount', dispatch, t)}
                                    </label>

                                    <input type="text" className="form-control fs-7 fw-normal" id='Amount'
                                        value={formik.values.Amount}
                                        //  value={typeof formik.values.Amount === 'number' ? formik.values.Amount.toFixed(DecimalPlaces) : formik.values.Amount || '0'}
                                        name='Amount'

                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value === '') {
                                                formik.setFieldValue('Amount', '');
                                                return;
                                            }
                                            if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                formik.setFieldValue('Amount', value);
                                                handleChange('Amount', e);
                                            }
                                        }}
                                        onBlur={(e) => {
                                            const formatted = formatNumberCustomoriginal(
                                                cultureInfoName.toString(),
                                                e.target.value,
                                                decimalPlaces
                                            );

                                            formik.setFieldValue('Amount', formatted);

                                        }}
                                        disabled={ShowNetAmount || ShowQuantity}
                                    />


                                    <div style={{ paddingRight: 20 }}>
                                        {formik.touched.Amount && formik.errors.Amount && (
                                            <p className='errorMsg'>{formik.errors.Amount as string}</p>
                                        )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Description' })}>
                            <div className='row'>
                                <div className="col-lg-12 mb-12" >
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t(`Description`)} */}
                                        {getValueFromResource('Description', dispatch, t)}
                                    </label>
                                    <textarea
                                        rows={4}
                                        cols={50}
                                        placeholder=
                                        // {t('Enter your text here...')}
                                        {getValueFromResource('Enter your text here...', dispatch, t)}
                                        id='Notes' value={formik.values.Description}
                                        className="form-control fs-7 fs-7 fw-normal"
                                        onChange={formik.handleChange('Description')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={clsx('tab-pane', { active: tab === 'Attachment' })}>
                            {/* <AttachmentUpload
                                Id={AccountExpenseEntryId}
                                onupdateTempAttachmentId={updateTempAttachmentId}
                                clearRef={attachmentUploadClearRef}
                                AccountAttachmentTypeId={1}
                            />
                            {tab === 'Attachment' && (AccountExpenseEntryId && AccountExpenseEntryId !== 0 && AccountExpenseEntryId !== '00000000-0000-0000-0000-000000000000' && AccountExpenseEntryId !== '') ? (
                                <GetAttachments Id={AccountExpenseEntryId} AccountAttachmentTypeId={1} IsShowEmployeeInformation={false} />
                            ) : null} */}
                            <AttachmentUpload
                                Id={AccountExpenseEntryId}
                                onupdateTempAttachmentId={updateTempAttachmentId}
                                clearRef={attachmentUploadClearRef}
                                AccountAttachmentTypeId={1}
                            />
                            {tab === 'Attachment' && (AccountExpenseEntryId && AccountExpenseEntryId !== 0 && AccountExpenseEntryId !== '00000000-0000-0000-0000-000000000000' && AccountExpenseEntryId !== '') ? (
                                <GetAttachments Id={AccountExpenseEntryId} AccountAttachmentTypeId={1} IsShowEmployeeInformation={false} isDisabled={true} />
                            ) : null}
                        </div>
                        {customFieldsArray && customFieldsArray.length > 0 &&
                            <div className={clsx('tab-pane', { active: tab === 'CustomField' })}>
                                <div className='row'>
                                    {customFieldsArray.filter((x: any) => !x.IsDisabled && x.DatabaseFieldName !== '').map((x: any, index: any) =>
                                        <Fragment key={index}>
                                            {x.MasterCustomDataTypeName == "Drop-Down" && (
                                                <>
                                                    <div key={index} className={"col-md-6 mb-3 "}>
                                                        <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                        <Select
                                                            name={x.DatabaseFieldName}
                                                            className="basic-single fs-7 fw-normal"
                                                            // onChange={(e) => formik.setFieldValue(x.DatabaseFieldName, e?.value)}
                                                            onChange={(e: any) => onCustomFieldChange(x.DatabaseFieldName, e?.value)}
                                                            styles={dropDownSelectionStyles}
                                                            value={formik.values[x.DatabaseFieldName] ? { value: formik.values[x.DatabaseFieldName], label: formik.values[x.DatabaseFieldName] } : { value: 'None', label: 'None' }}
                                                            options={[
                                                                { value: 'None', label: 'None' },  // Add "None" option at the start
                                                                ...x.DropDownOptions
                                                                    ? x.DropDownOptions.split("+").map((value: any) => ({ value, label: value }))
                                                                    : []
                                                            ]}
                                                            //options={x.DropDownOptions ? x.DropDownOptions.split("+").map((value: any, index: any) => ({ value, label: value })) : []}
                                                            required={x.IsRequired ? x.IsRequired : ""}
                                                            maxMenuHeight={maxMenuHeight}
                                                        />
                                                        {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Drop-Down')) && (
                                                            <div style={{ paddingRight: 20 }}>
                                                                {formik.touched[x.DatabaseFieldName] && formik.errors[x.DatabaseFieldName] &&
                                                                    <p className='errorMsg'>{formik.errors[x.DatabaseFieldName] as string}</p>
                                                                }
                                                            </div>
                                                        )}
                                                    </div>

                                                </>
                                            )}
                                            {x.MasterCustomDataTypeName == "Date" && (
                                                <>
                                                    <div key={index} className={"col-md-6 mb-3"}>
                                                        <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                        <div className="wrapper">
                                                            <DatePicker
                                                                name={x.DatabaseFieldName}
                                                                calendarStartDay={calendarStartDay}
                                                                ////onChange={(date) => formik.setFieldValue(`${x.DatabaseFieldName}`, date ? moment(date).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase()))}
                                                                // onChange={(date) => onCustomFieldChange(x.DatabaseFieldName, date ? moment(date).format(CurrentCultureDateFormat.toUpperCase()) : moment().format(CurrentCultureDateFormat.toUpperCase()))}
                                                                // selected={(formik.values[x.DatabaseFieldName] ? moment(formik.values[x.DatabaseFieldName], CurrentCultureDateFormat.toUpperCase()).toDate() : moment().toDate())}
                                                                onChange={(date) => onCustomFieldChange(x.DatabaseFieldName, date ? moment(date).format(customFieldInsertionFormat) : moment(new Date()).format(customFieldInsertionFormat))}
                                                                selected={(formik.values[x.DatabaseFieldName] ? dateFormatByAccountCulture(formik.values[x.DatabaseFieldName], cultureInfoName.toString()) : new Date())}
                                                                className="form-control form-con fs-7 fw-normal col-md-1"
                                                                dateFormat={CurrentCultureDateFormat.toString()}
                                                            //onBlur={() => handleBlurValidateAll()}
                                                            />
                                                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                                        </div>
                                                        {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Date')) && (
                                                            <div style={{ paddingRight: 20 }}>
                                                                {formik.touched[x.DatabaseFieldName] && formik.errors[x.DatabaseFieldName] &&
                                                                    <p className='errorMsg'>{formik.errors[x.DatabaseFieldName] as string}</p>
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            )}

                                            {(x.MasterCustomDataTypeName == "Text") && (
                                                <div key={index} className={"col-md-6 mb-3"}>
                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                    <input
                                                        name={x.DatabaseFieldName}
                                                        id={x.DatabaseFieldName}
                                                        value={formik.values[x.DatabaseFieldName] ? formik.values[x.DatabaseFieldName] : ''}
                                                        // onChange={formik.handleChange(`${x.DatabaseFieldName}`)}
                                                        onChange={(e) => onCustomFieldChange(x.DatabaseFieldName, e.target.value)}
                                                        className={"form-control form-con input-sm custom-field custom-field"}
                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                        type="text"
                                                    //onBlur={() => handleBlurValidateAll()}
                                                    />
                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Text')) && (
                                                        <div style={{ paddingRight: 20 }}>
                                                            {formik.touched[x.DatabaseFieldName] && formik.errors[x.DatabaseFieldName] &&
                                                                <p className='errorMsg'>{formik.errors[x.DatabaseFieldName] as string}</p>
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {(x.MasterCustomDataTypeName == "Number") && (
                                                <div key={index} className={"col-md-6 mb-3"}>
                                                    <label className={"form-label fs-7 fw-normal mb-2"}>{x.CustomFieldCaption}</label>
                                                    <input
                                                        name={x.DatabaseFieldName}
                                                        id={x.DatabaseFieldName}
                                                        value={formik.values[x.DatabaseFieldName] ? formik.values[x.DatabaseFieldName] : ''}
                                                        //onChange={formik.handleChange(`${x.DatabaseFieldName}`)}
                                                        //onChange={(e) => onCustomFieldChange(x.DatabaseFieldName, e.target.value)}
                                                        onChange={async (e) => {
                                                            const value = e.target.value;
                                                            if (validateCultureNumber(value, cultureInfoName.toString(), decimalPlaces)) {
                                                                await formik.setFieldValue(x.DatabaseFieldName, value);
                                                                await formik.setFieldTouched(x.DatabaseFieldName, true, true);
                                                            }
                                                        }}
                                                        onBlur={async (e) => {
                                                            const formatted = formatNumberCustomoriginal(
                                                                cultureInfoName.toString(),
                                                                e.target.value,
                                                                decimalPlaces
                                                            );
                                                            await formik.setFieldValue(x.DatabaseFieldName, formatted);
                                                            await formik.setFieldTouched(x.DatabaseFieldName, true, true);
                                                            formik.validateField(x.DatabaseFieldName);
                                                        }}
                                                        className={"form-control form-con input-sm custom-field custom-field"}
                                                        //max={x.MaximumValue !== undefined ? parseFloat(x.MaximumValue) : undefined}
                                                        //min={x.MinimumValue !== undefined ? parseFloat(x.MinimumValue) : undefined}
                                                        required={x.IsRequired ? x.IsRequired : ""}
                                                        type="text"
                                                    // onBlur={() => handleBlurValidateAll()}
                                                    />
                                                    {(x.IsRequired || (!x.IsRequired && x.MasterCustomDataTypeName === 'Number')) && (
                                                        <div style={{ paddingRight: 20 }}>
                                                            {formik.touched[x.DatabaseFieldName] && formik.errors[x.DatabaseFieldName] &&
                                                                <p className='errorMsg'>{formik.errors[x.DatabaseFieldName] as string}</p>
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                        }
                    </div>

                </>
                }
                {/* {Object.keys(formik.errors).length > 0 && (
                    <div className="mt-3 alert alert-danger">
                        <strong>{t('Error Summary')}:</strong>
                        <ul>
                            {Object.keys(formik.errors).map((fieldName, index) => (
                                <li key={index}>{formik.errors[fieldName] as string}</li>
                            ))}
                        </ul>
                    </div>
                )} */}
                {(Object.keys(formik.errors).length > 0 || apiErrors.length > 0) && (

                    <div className="mt-3 alert alert-danger">
                        <strong>
                            {/* {t('Error Summary')}: */}
                            {getValueFromResource('Error Summary', dispatch, t)}:
                        </strong>
                        <ul>
                            {/* Show Formik validation errors */}
                            {Object.keys(formik.errors).map((fieldName, index) => (
                                <li key={index}>{formik.errors[fieldName] as string}</li>
                            ))}

                            {/* Show API validation errors */}
                            {apiErrors.map((error, index) => (
                                <li key={`api-${index}`}>{error}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            ref={closeButtonRef1}
                            type="button"
                            className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                            id="kt_OffCanvas"
                            onClick={handleCloseOnClickEvent}
                        >
                            {/* {t('Cancel')} */}
                            {getValueFromResource('Cancel', dispatch, t)}
                        </button>
                        <div>
                        </div>

                        <button type="button" data-kt-element='send'

                            className={`btn btn-primary btn-bs-btn-font-weight btn-sm ${LockButton ? 'disableClick' : ''}`}
                            //id="kt_OffCanvas"
                            //id={`${!formik.isValid ? '' : 'kt_OffCanvas'}`}
                            onClick={() => formik.handleSubmit()}
                            disabled={!formik.isValid || LockButton}

                        >
                            {/* {t('Save')} */}
                            {getValueFromResource('Save', dispatch, t)}
                        </button>
                    </div>
                </div>
            </div>


        </>

    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default ExpenseEntryForm